import { useQuery, UseQueryOptions } from 'react-query';

import { SettingsApi } from 'api/SettingsApi';

const SITE_INFO_QUERY_KEY = 'site-info-query';

export const useSiteInfoQuery = (
  queryOptions?: UseQueryOptions<{ address: string[] }>
) => {
  return useQuery<{ address: string[] }>(
    SITE_INFO_QUERY_KEY,
    async () => {
      const { address } = await SettingsApi.fetchSiteInfo();

      return {
        address: address
          ?.replace(/<\/?[^>]+(>|$)|(\n)/g, 'divider')
          ?.split('divider')
          ?.filter(Boolean),
      };
    },
    {
      retry: false,
      cacheTime: 0,
      ...queryOptions,
    }
  );
};
